<template>
    
    <div v-if="user.length > 0" class="sessionsPanelDiv mb-2">

        <div class="myCenter">

            <div class="barTitleDiv">

                <div class="w-32 me-4">

                    <label class="barTitleText">{{$t('menu.pitches')}}</label>
                </div>

                <div>
            
                    <button v-if="hide" @click="hide=!hide"
                        class="SessionsfontAwesomeButton">
                        
                        <font-awesome-icon icon="filter" size="lg"/> 
                    </button>            
                </div>
            </div>
        </div>



        <div v-show="!hide" class="sessionsPanelStickyBar">

            <div class="myCenter">
                
                <button @click="hide=!hide"
                    class="SessionsfontAwesomeButton">
                    
                    <font-awesome-icon icon="times-circle" size="2x"/> 
                </button>
            </div>


            <div class="flex flex-row justify-around mt-2 lg:mt-4 px-1 lg:px-3 items-center mb-10 lg:mb-2 w-full">
                        
                <!-- <div class=" lg:mt-0 w-32 lg:w-48 text-xs lg:text-lg">
                    <vue-multi-select
                    v-model="playersGroupsOptionsProxy"
                    :btnLabel="groupsBtnLabel"
                    :position="position2"
                    :options="singleOptions"
                    @input="playersGroupsOptionsSelection"
                    :selectOptions="playersGroupsOptions"/>
                </div> -->


                    <div class=" lg:mt-0 w-32 lg:w-48 text-xs lg:text-lg">
                        <vue-multi-select
                        v-model="pitchTypesOptionsProxy"
                        :btnLabel="pitchesBtnLabel"
                        :position="position2"
                        :options="langOptions"
                        @input="pitchTypesOptionsSelection"
                        :selectOptions="pitchTypesOptions"/>
                    </div>

                    <div class=" lg:mt-0">
                        <vue-multi-select
                        v-model="countiesOptionsProxy"
                        :btnLabel="countiesBtnLabel"
                        :position="position"
                        :options="langOptions2"
                        @input="countiesOptionsSelection"
                        :selectOptions="countiesOptions"/>
                    </div>

            </div> 
                        

            <div class="pitchPanelTimeFilterDiv">

                <div class="flex flex-row mb-2 lg:mb-4 lg:me-5  lg:mt-0">
                    
                    <div class="me-4 myCenterCol mr-1 lg:me-5">

                        <label :style="{backgroundColor: timeAfterColor}"
                        class="rounded w-full lg:me-4"><strong> {{$t('sessions.after')}}</strong></label>

                        <vue-timepicker 
                        format="hh:mm A" v-model="startTimeAfter"></vue-timepicker>                        
                    </div>

                    <div class="myCenterCol ms-1 lg:ms-5">

                        <label :style="{backgroundColor: timeBeforeColor}"
                        class="rounded-lg w-full lg:me-4"><strong>{{$t('sessions.before')}}</strong></label>

                        <vue-timepicker 
                        format="hh:mm A" v-model="startTimeBefore"></vue-timepicker>
                    </div>
                </div>

                <div class="items-center mb-20 mt-2 lg:mt-8 justify-center">

                    <button @click="checkTime"
                    class="sessionsPanelTimeFilterButton">
                <label> {{$t('sessions.timeFilter')}}</label> </button>
                </div>
            </div>

            <div class="flex flex-row justify-between px-3 items-baseline mb-4 lg:mb-2 -mt-4 lg:mt-0 w-full">
                
                <!-- <div class="lg:flex lg:flex-row lg:justify-center w-16 lg:w-full lg:my-4 lg:mt-5">
                    <input v-model="searchInput" @input="setSlots(true)"
                        class="sessionsPanelSearchField" placeholder="Names Search">
                </div>
                 -->
                <div class="mr-2 me-2 w-32 lg:w-48 text-xs lg:text-lg">

  
                </div>

            </div> 

            <div class="bg-pink-100">

                <!-- <div class="mb-1 lg:mb-2 w-full mt-4 flex flex-row-reverse items-between justify-between">
                    
                    <div>
                        <button @click="goNextOrPrevious(true)"
                                class=" mr-1 lg:mr-2 w-24 rounded-full h-8 lg:h-16 text-xs lg:text-lg lg:mt-0
                                bg-pink-500 text-white font-bold uppercase border-blue-500 border">
                        {{$t('pitch.next')}} </button>
                    </div>

                    <div>

                        <button v-if="!isToday" @click="goNextOrPrevious(false)"
                            class=" mr-1 g:ml-2 w-24 rounded-full h-8 lg:h-16 text-xs lg:text-lg lg:mt-0
                            bg-pink-500 text-white font-bold uppercase border-blue-500 border">
                            {{$t('pitch.previous')}} </button>
                    </div>                                  
                </div> -->

                <!-- <div class="myCenter mt-2">
                    <div class="flex flex-row justify-center text-center border mb-1 border-red-900 z-50">

                        <datepicker v-model="dayDate" format="yyyy-MM-dd" :disabled-dates="{customPredictor: disableDates}"/>
                    </div>

                    <div class="flex flex-row justify-center w-40 lg:w-full">
                        <p class="ps-1 mb-1 lg:mb-2 w-32 lg:w-64 bg-blue-300 text-center
                            rounded-full border-blue-800 border-2 lg:border-4">
                        <strong>{{ panelObject.dayDate }} </strong></p>
                    </div>
                </div>                     -->
            </div>
        </div>

        <div class="myRedNote">

            <!-- <label>{{$t('player.cancelNote')}} 12 {{$t('player.cancelNote2')}}</label> -->
            <label>{{$t('player.newCancelNote')}} 2 {{$t('player.newCancelNote2')}}</label>

        </div>

        <div class="flex justify-around lg:justify-center w-full items-center">

            <div v-if="!disablePage" class="text-sm lg:text-lg ms-4">
    
                <label v-if="user[0].coins > 0" class="lg:mb-2 w-40">
                    <p class="myCenter2"> <strong>{{$t('classes.points')}} </strong>
                <strong class="myNormalText myResponsiveRounded">{{user[0].coins}}</strong> </p></label>

                <label v-else class="myCenter">
                    <p class=" myRedText myResponsiveRounded"> 
                    {{$t('sessions.youHave')}} <strong>{{user[0].coins}}</strong> {{$t('profile.points')}}</p></label>
            </div>

            <div class="myCenter lg:my-4 lg:mt-5">
                            
                <input v-model="searchInput" @input="setSlots(true)"
                class="sessionsPanelSearchField" placeholder="Names Search">
            </div>
        </div>
    </div> 
                    
</template>

<script>

import Vue from 'vue';

import componentsHelpers from '../../classes/componentHelpers';

import vueMultiSelect from 'vue-multi-select'; 
import 'vue-multi-select/dist/lib/vue-multi-select.css';

// import Datepicker from 'vuejs-datepicker';

// import toggleSwitch from 'vuejs-toggle-switch';

// import myToggleSwitch from '../controls/MySwitch';


import moment from 'moment';

// Main JS (in UMD format)
// https://github.com/phoenixwong/vue2-timepicker
import VueTimepicker from 'vue2-timepicker'
// CSS
import 'vue2-timepicker/dist/VueTimepicker.css'

//https://github.com/charliekassel/vuejs-datepicker#date-formatting

import SearchComponent from '../../components/SearchComponent';
import componentHelpers from '../../classes/componentHelpers';
import componentsMethods from '../../classes/componentsMethods';

export default {

    created(){

        // console.log(`panelObject: ${JSON.stringify(this.panelObject.categorizedSlots)}`)
    },

    mounted(){
        
        // console.log(`user.length: ${this.user.length}`);
        // this.slot = this.panelObject.categorizedSlots.filter(item=>item);
        this.setSlots();
    },

    props:{

        refreshMap: {

            type: Function
        },

        playersGroupsOptions: {

            type: Array
        },

        countiesOptions: {

            type: Array
        },

        pitchTypesOptions: {

            type: Array
        },

        toastIt:{

            type: Function
        },

        setDate: {

            type: Function
        },

        openMapModal: {

            type: Function
        },

        allSlots:{

            type: Array
        },

        fixedDayDate: '',

        openMapModal: {

            type: Function
        },

        panelObject:{
            
            type: Object
        },

        disablePage: false,

        user:{

            type: Array
        },
    },

    components:{
    
        vueMultiSelect,
        // myToggleSwitch,        
        // Datepicker,
        VueTimepicker,
        SearchComponent
        
    },

    computed: {

        isToday(){


                if(this.panelObject.dayDate == moment(new Date()).format(moment.HTML5_FMT.DATE))
                {
                    // console.log(`return true`);
                    return true;
                }

            // console.log(`return false`);
            return false;
        }
    },

    methods: {

        disableDates(date){

            const todayDate = moment(this.todayDate).format(moment.HTML5_FMT.DATE);

           const newDate = moment(date).format(moment.HTML5_FMT.DATE);

            const maximumDate = moment(todayDate).add('15','days').format(moment.HTML5_FMT.DATE);

           if(newDate < todayDate)
           {    
               
                return true;                

           }
           else if(newDate > maximumDate){

               return true
           }
           else{

               return false
           }
        },
    


        changeDate(value){

            // console.log(`input changed to : ${value}`);
        },  

        setNewDate(newDate){

            // console.log(`new Date: ${newDate}`);
            this.panelObject.dayDate = newDate;
            this.dayDate  =  newDate;
            this.ignoreDateChange = true;
        },

        itemIsSelected(selected){

            // console.log(`selected: ${selected}`)
        },

        changeMinimizeAll(){

            this.panelObject.minimizeAll = !this.panelObject.minimizeAll;

            const savingValue = this.minimizeAll ? 1 : 0;

            localStorage.setItem('sessionsMinimizeAll', savingValue);
        },

        pitchTypesOptionsSelection(selectedOption){
          
          this.setSlots();
        },

        playersGroupsOptionsSelection(selectedOption){
            
        },

        countiesOptionsSelection(selectedOption){

            this.setSlots();
        },

      filterSelectionSlots(){
          
          // console.log(`in filterSelectionSlots`);
          let tempSlots = [];

          for(let i = 0; i < this.pitchTypesOptionsProxy.length; i++){

              const optionProxy = this.pitchTypesOptionsProxy[i];
              
          // console.log(`optionProxy are ${JSON.stringify(optionProxy)}`);
              const categoriesFilter = (item) => {

                      if(item.two_pitch.type.id == optionProxy.id)
                      {   
                          
                          return true;
                      }                            

                      return false;
              };

              const temp = this.panelObject.categorizedSlots.filter(categoriesFilter);
              // console.log(`temp is: ${JSON.stringify(temp)}`);

              if(temp.length > 0){

                  tempSlots.push(...temp);                    
              }
          }

          this.panelObject.categorizedSlots = [...new Map(tempSlots.map(item => [item.id, item])).values()];
      },

      filterByAreas(){

                    // console.log(`in filterSelectionSlots`);
          let tempSlots = [];

          for(let i = 0; i < this.countiesOptionsProxy.length; i++){

              const optionProxy = this.countiesOptionsProxy[i];
              
          // console.log(`optionProxy are ${JSON.stringify(optionProxy)}`);
              const categoriesFilter = (item) => {

                      if(item.two_pitch.location.location_city.location_country_county.id == optionProxy.id)
                      {   
                          
                          return true;
                      }                            

                      return false;
              };

              const temp = this.panelObject.categorizedSlots.filter(categoriesFilter);
              // console.log(`temp is: ${JSON.stringify(temp)}`);

              if(temp.length > 0){

                  tempSlots.push(...temp);                    
              }
          }

          this.panelObject.categorizedSlots = [...new Map(tempSlots.map(item => [item.id, item])).values()];

      },

          slotsCategoriesSelection(selectedOption){
            
            this.setSlots();
        },


        sortTimes(array) {
            
            return array.sort(function (a, b) {
                if (parseInt(a.start_time.split(":")[0]) - parseInt(b.start_time.split(":")[0]) === 0) {
                    return parseInt(a.start_time.split(":")[1]) - parseInt(b.start_time.split(":")[1]);
                } else {
                    return parseInt(a.start_time.split(":")[0]) - parseInt(b.start_time.split(":")[0]);
                }
            })
        },

        dayOfWeekAsString(dayIndex) {
            
            return [this.$t('slot.sunday'), this.$t('slot.monday'), this.$t('slot.tuesday'),this.$t('slot.wednesday'),this.$t('slot.thursday'),this.$t('slot.friday'),this.$t('slot.saturday')][dayIndex];
        },


         setSlots(fromSearch = false){
             
             if(this.allSlots.length < 1){
                 
                 return;
             }
        // console.log(`allSlots: ${JSON.stringify(this.allSlots)}`);
            // console.log(`allSlots.length: ${this.allSlots.length}`);

            const selectionDay = this.dayOfWeekAsString(new Date(this.panelObject.dayDate).getDay());

                // console.log(`selectionDay: ${selectionDay}`);
            // const equalMethod = this.isEqualToWeeKDay;
            const equalMethod = componentsMethods.isEqualToWeeKDayForPitch;

            const weekDayFilter = (item) => {
                
             const value =  equalMethod(item, selectionDay, this.panelObject.dayDate);

                // console.log(`value: ${value}`);
             return value;
              };

            this.weekDayCategorizedSlots = this.allSlots.filter(weekDayFilter);

            // console.log(`weekDayCategorizedSlots: ${JSON.stringify(this.weekDayCategorizedSlots)}`);

            // console.log(`allSlots: ${JSON.stringify(this.allSlots)}`);

            this.timedCategorizedSlots = this.weekDayCategorizedSlots.filter(item => item);
        
          if(this.savedStartTimeAfter != '' && this.savedStartTimeBefore != ''){

              this.filterByTime(this.savedStartTimeAfter, this.savedStartTimeBefore);
          }
          else if(this.savedStartTimeAfter != ''){

              this.filterByTime(this.savedStartTimeAfter,null);
          }
          else if(this.savedStartTimeBefore != ''){

              this.filterByTime(null ,this.savedStartTimeBefore);
          }
          else{
              
              this.panelObject.categorizedSlots = this.timedCategorizedSlots;
          }


            // console.log(`panelSlots: ${JSON.stringify(this.panelObject.categorizedSlots)}`);

            if(this.pitchTypesOptionsProxy.length > 0){

                this.filterSelectionSlots();
            }

            if(this.countiesOptionsProxy.length > 0){

                this.filterByAreas();
            }

            if(this.searchInput != ''){

                this.doSearch();
            }else{

                this.refreshMap();
            }

      },

        doSearch(){

            let saveSearchResultsMethod = this.saveSearchResults; 
        
            //console.log(`variables are: ${this.searchInput} and ${JSON.stringify(this.panelObject.categorizedSlots)}`) 
        
            this.$search(this.searchInput, this.panelObject.categorizedSlots, { keys: ['two_pitch.business.name', 'two_pitch.name',
            'two_pitch.type.name'], findAllMatches: true,  threshold: 0.1,
            }).then(results => {
            
               //console.log(`slots results are: ${JSON.stringify(results)}`);
                
                saveSearchResultsMethod(results);
            });
        },

         saveSearchResults(results){

            this.panelObject.categorizedSlots = results.filter(item=>item);
            
            this.refreshMap();            
            this.SearchResults = results;
        },

        filterSlotsWithSearchResults(results){

            this.panelObject.categorizedSlots = results;
        },

        isInvalidTime(time){

            if(time.includes('h') || time.includes('m') ||  time =='' || (time.includes('A') && !time.includes('AM')))
            {
                return true;
            }
            else{

                return false;
            }
        },

        checkTime(){  

            // console.log(`in checktime`);

            this.timeBeforeColor="";
            this.timeAfterColor="";
            this.savedStartTimeAfter = '';
            this.savedStartTimeBefore = '';

            if((this.isInvalidTime(this.startTimeAfter) && this.isInvalidTime(this.startTimeBefore))){

                // this.timeBeforeColor="#feb2b2";
                this.timeBeforeColor= this.redHighlight;
                this.timeAfterColor=this.redHighlight;
                this.toastIt(this.$t('sessions.bothTimesInvalid'), 3);
                this.setSlots();
            }
            else if(!this.isInvalidTime(this.startTimeAfter) && !this.isInvalidTime(this.startTimeBefore)){

                this.savedStartTimeAfter = this.startTimeAfter;
                this.savedStartTimeBefore = this.startTimeBefore;

                this.setSlots();    
            }
            else if(!this.isInvalidTime(this.startTimeAfter)){
                

                this.toastIt(this.$t('sessions.endTimeInvalid'), 3);

                this.savedStartTimeAfter = this.startTimeAfter;
                this.timeBeforeColor=this.redHighlight;

                this.setSlots();    
            }
            else if(!this.isInvalidTime(this.startTimeBefore)){

                this.toastIt(this.$t('sessions.startTimeInvalid'), 3);

                this.savedStartTimeBefore = this.startTimeBefore;
                this.timeAfterColor=this.redHighlight;

                this.setSlots();
            }
            else{
                this.toastIt(this.$t('sessions.timeSearchInvalid'), 3);
                this.setSlots();
            }
        },

        filterByTime(time1, time2){

            const timeFilter = (item) => {
                
                const startTimeDate = new Date('1970/01/01 ' + item.start_time  + '')
                                
                if(time1 != null && time2 != null)
                {
                    const timeAfterDate = new Date('1970/01/01 ' + time1  + '');
                
                    const timeBeforeDate = new Date('1970/01/01 ' + time2  + '');

                    if(startTimeDate >= timeAfterDate && startTimeDate <= timeBeforeDate){
                        
                        return true;
                    }

                    return false;
                }
                else if(time1 != null){

                    const timeAfterDate = new Date('1970/01/01 ' + time1  + '');
    
                    if(startTimeDate >= timeAfterDate)
                    {

                        return true;
                    }
                    
                    return false;
                }

                else if(time2 != null){
                    
                    const timeBeforeDate = new Date('1970/01/01 ' + time2  + '');

                    if(startTimeDate <= timeBeforeDate)
                    {

                        return true;
                    }

                    return false;
                }
                else{
                    
                    return true;
                }
            } 

            this.panelObject.categorizedSlots = this.timedCategorizedSlots.filter(timeFilter);
        },

        goNextOrPrevious(value){
            
            for(let i = 0; i < this.panelObject.categorizedSlots.length; i ++)
            {

                Vue.set(this.panelObject.categorizedSlots,i, this.panelObject.categorizedSlots[i]);
            }

            let dayDate = moment(this.panelObject.dayDate);

            if(value){

                dayDate = moment(dayDate).add(1, 'days');
                
                // console.log(`dayDate before: ${this.panelObject.dayDate}`)

                // this.panelObject.dayDate = moment(dayDate).format(moment.HTML5_FMT.DATE);
                // this.dayDate  =  this.panelObject.dayDate;
                
                this.setNewDate(moment(dayDate).format(moment.HTML5_FMT.DATE));
                // console.log(`dayDate after: ${this.panelObject.dayDate}`)

                this.setSlots();

                this.setDate(moment(dayDate).format(moment.HTML5_FMT.DATE), true);
            }

            else{

                if(dayDate > moment()){
                    
                    dayDate = moment(dayDate).subtract(1, 'days');

                    // this.panelObject.dayDate = moment(dayDate).format(moment.HTML5_FMT.DATE);
                    // this.dayDate  =  this.panelObject.dayDate;
                    
                    this.setNewDate(moment(dayDate).format(moment.HTML5_FMT.DATE));

                    this.setSlots();
                    
                    this.setDate(moment(dayDate).format(moment.HTML5_FMT.DATE), false);

                }
            }


        },

       changeDayDate(date) {
        

           const todayDate = moment(this.todayDate).format(moment.HTML5_FMT.DATE);
            // console.log(`todayDate: ${JSON.stringify(todayDate)}`)


           const newDate = moment(date).format(moment.HTML5_FMT.DATE);
        //    console.log(`new  date: ${newDate}`);

            const maximumDate = moment(todayDate).add('14','days').format(moment.HTML5_FMT.DATE);

           if(newDate < todayDate)
           {    
               
            // console.log(`newDate < todayDate`);
                
                // this.panelObject.dayDate = todayDate;
                // this.dayDate  =  this.panelObject.dayDate;

                this.setNewDate(todayDate);

                componentsHelpers.toastIt(this.$toasted, this.$t('sessions.cantPickOldDate'), 3, 'outline', true);

                this.setSlots();

                return
           }
           else if(newDate > maximumDate){

                // console.log(`newDate > maximumDate`);

                // this.panelObject.dayDate = todayDate;
                // this.dayDate  =  this.panelObject.dayDate;
                this.setNewDate(todayDate);

                componentsHelpers.toastIt(this.$toasted, this.$t('sessions.cantPickBiggerDate'), 3, 'outline', true);
           }
           else{

                // console.log(`both False`);

                // this.panelObject.dayDate = newDate;
                // this.dayDate  =  newDate;
                this.setNewDate(newDate);

                // this.setDate(moment(newDate).format(moment.HTML5_FMT.DATE), true);

                this.setSlots();
           }

           if(this.minimizeAll){

                if(typeof this.$refs.slotCardChild === 'undefined'){
                    
                    return;
                }
                
               for(let i = 0; i< this.$refs.slotInfoChild.length; i++)
               {
                   
                   this.$refs.slotInfoChild[i].setIsBooked(this.panelObject.todayDate);
               }
           }
           else{
                
               if(typeof this.$refs.slotCardChild === 'undefined'){

                   return;
               }

               for(let i = 0; i< this.$refs.slotCardChild.length; i++){
                    
                    this.$refs.slotCardChild[i].setIsBooked(this.panelObject.todayDate);
                }
           }
        },

        format(value, event) {
            
            return moment(value).format('yyyyy-MM-dd')
        }

    },

    data: function(){

        return{

            ignoreDateChange: false,
            hide: true,
            showOnlyTheOneSLot: false,
            selectedOneSlot: null,
            disableButton: false,
            onlyOnline: false,
            highlightedLcoation: null,
            locations: [],
            searchInput: '',
            SearchResults: [],
           
            minimizeAll: true,

           
            timedCategorizedSlots:[],
            weekDayCategorizedSlots:[],
            slot:[],
            bookings: [],
            startTimeAfter: '',
            startTimeBefore: '',
            savedStartTimeAfter: '',
            savedStartTimeBefore: '',

            playersGroupsOptionsProxy: [],

            countiesOptionsProxy: [],

            pitchTypesOptionsProxy: [],

            pitchesBtnLabel: values => this.pitchTypesOptionsProxy.length > 0 ?  (this.$i18n.locale == 'ar' ? this.pitchTypesOptionsProxy[0].name_ar: this.pitchTypesOptionsProxy[0].name) : this.$t('pitch.pitchType'),

            groupsBtnLabel: values => this.playersGroupsOptionsProxy.length > 0 ? ` ${this.playersGroupsOptionsProxy[0].name}` : this.$t('player.forGroup'),

            countiesBtnLabel: values => this.countiesOptionsProxy.length > 0 ? (this.$i18n.locale == 'ar' ? this.countiesOptionsProxy[0].ar_name : this.countiesOptionsProxy[0].name) : this.$t('pitch.selectArea'),
            position: this.$i18n.locale == 'ar' ? 'bottom-left' :  'bottom-right',
            position2: this.$i18n.locale == 'ar' ?   'bottom-right' : 'bottom-left',

            singleOptions: {
            
                multi: false,

                cssSelected: option => (option.selected ? { 'background-color': '#5764c6' } : ''),
            },

            options: {
                
                multi: true,

                cssSelected: option => (option.selected ? { 'background-color': '#5764c6' } : ''),
            },


            langOptions: {
                
                multi: false,

                labelName: this.$i18n.locale == 'ar' ? 'name_ar': 'name',

                cssSelected: option => (option.selected ? { 'background-color': '#5764c6' } : ''),
            },

            langOptions2: {
                
                multi: true,

                labelName: this.$i18n.locale == 'ar' ? 'ar_name': 'name',

                cssSelected: option => (option.selected ? { 'background-color': '#5764c6' } : ''),
            },

            timeBeforeColor: '',
            timeAfterColor: '',
            dayDate: this.panelObject.dayDate,
            todayDate: this.fixedDayDate,

            redHighlight: '#DC2626',
        }
    },

    watch: {
        
        dayDate: function(val, oldVal) {

            oldVal = moment(oldVal).format(moment.HTML5_FMT.DATE);

            val = moment(val).format(moment.HTML5_FMT.DATE);
            // console.log(`old value: ${oldVal}`);
            // console.log(`new value: ${val}`);

            if(oldVal != moment(val).format(moment.HTML5_FMT.DATE)){

                this.changeDayDate(val);
            }else{

            }
        },

    }
}
</script>

<style>

</style>